import { Plugins } from '@capacitor/core'

const { Http } = Plugins

export default Http
